import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { BaseHttpService } from '@framework/services';
import { FollowInputApiModel } from '../models/api-models/input';
import { FollowOutputApiModel } from '../models/api-models/output';

@Injectable()
export class FollowHttpService extends BaseHttpService {
    constructor(httpClient: HttpClient) {
        super(httpClient, '/follows');
    }

    public follow(payload: FollowInputApiModel) {
        return this.post('/', payload).pipe(map((response: any) => {
            return new FollowOutputApiModel(response);
        }));
    }

    public unfollow(id: number, resource: string) {
        return this.delete(`/${id}/?resource=${resource}`).pipe(map((response: any) => {
            return response;
        }));
    }

}
